import React, { useEffect, useRef, useState } from "react";
import { AttachMini, EllipsisVertical, SendMini } from "../../assets/SvgIcons";
import { io } from "socket.io-client";

// const conversations = [
//   {
//     sender_name: "John Doe",
//     sender_message: "Hey, how are you doing?",
//     profile_image: "https://example.com/profile1.jpg",
//     chats: [
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Hey, how are you doing?",
//         timestamp: "2024-11-19 10:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "I'm good, thanks! What about you?",
//         timestamp: "2024-11-19 10:05 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Jane Smith",
//     sender_message: "Can you send me the report?",
//     profile_image: "https://example.com/profile2.jpg",
//     chats: [
//       {
//         message: "Can you send me the report?",
//         timestamp: "2024-11-18 02:30 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Sure, I’ll send it in a moment.",
//         timestamp: "2024-11-18 02:35 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Alice Johnson",
//     sender_message: "Meeting rescheduled to 3 PM.",
//     profile_image: "https://example.com/profile3.jpg",
//     chats: [
//       {
//         message: "Meeting rescheduled to 3 PM.",
//         timestamp: "2024-11-18 09:00 AM",
//         sent_by_user: false,
//       },
//       {
//         message: "Got it, thanks for letting me know!",
//         timestamp: "2024-11-18 09:05 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Bob Brown",
//     sender_message: "Are you free this weekend?",
//     profile_image: "https://example.com/profile4.jpg",
//     chats: [
//       {
//         message: "Are you free this weekend?",
//         timestamp: "2024-11-17 07:45 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Yes, let’s plan something!",
//         timestamp: "2024-11-17 07:50 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Emily Davis",
//     sender_message: "Happy Birthday! 🎉",
//     profile_image: "https://example.com/profile5.jpg",
//     chats: [
//       {
//         message: "Happy Birthday! 🎉",
//         timestamp: "2024-11-16 11:59 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Thank you so much! 😊",
//         timestamp: "2024-11-17 12:01 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Bob Brown",
//     sender_message: "Are you free this weekend?",
//     profile_image: "https://example.com/profile4.jpg",
//     chats: [
//       {
//         message: "Are you free this weekend?",
//         timestamp: "2024-11-17 07:45 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Yes, let’s plan something!",
//         timestamp: "2024-11-17 07:50 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Emily Davis",
//     sender_message: "Happy Birthday! 🎉",
//     profile_image: "https://example.com/profile5.jpg",
//     chats: [
//       {
//         message: "Happy Birthday! 🎉",
//         timestamp: "2024-11-16 11:59 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Thank you so much! 😊",
//         timestamp: "2024-11-17 12:01 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Bob Brown",
//     sender_message: "Are you free this weekend?",
//     profile_image: "https://example.com/profile4.jpg",
//     chats: [
//       {
//         message: "Are you free this weekend?",
//         timestamp: "2024-11-17 07:45 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Yes, let’s plan something!",
//         timestamp: "2024-11-17 07:50 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Emily Davis",
//     sender_message: "Happy Birthday! 🎉",
//     profile_image: "https://example.com/profile5.jpg",
//     chats: [
//       {
//         message: "Happy Birthday! 🎉",
//         timestamp: "2024-11-16 11:59 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Thank you so much! 😊",
//         timestamp: "2024-11-17 12:01 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Bob Brown",
//     sender_message: "Are you free this weekend?",
//     profile_image: "https://example.com/profile4.jpg",
//     chats: [
//       {
//         message: "Are you free this weekend?",
//         timestamp: "2024-11-17 07:45 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Yes, let’s plan something!",
//         timestamp: "2024-11-17 07:50 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Emily Davis",
//     sender_message: "Happy Birthday! 🎉",
//     profile_image: "https://example.com/profile5.jpg",
//     chats: [
//       {
//         message: "Happy Birthday! 🎉",
//         timestamp: "2024-11-16 11:59 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Thank you so much! 😊",
//         timestamp: "2024-11-17 12:01 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Bob Brown",
//     sender_message: "Are you free this weekend?",
//     profile_image: "https://example.com/profile4.jpg",
//     chats: [
//       {
//         message: "Are you free this weekend?",
//         timestamp: "2024-11-17 07:45 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Yes, let’s plan something!",
//         timestamp: "2024-11-17 07:50 PM",
//         sent_by_user: true,
//       },
//     ],
//   },
//   {
//     sender_name: "Emily Davis",
//     sender_message: "Happy Birthday! 🎉",
//     profile_image: "https://example.com/profile5.jpg",
//     chats: [
//       {
//         message: "Happy Birthday! 🎉",
//         timestamp: "2024-11-16 11:59 PM",
//         sent_by_user: false,
//       },
//       {
//         message: "Thank you so much! 😊",
//         timestamp: "2024-11-17 12:01 AM",
//         sent_by_user: true,
//       },
//     ],
//   },
// ];

const socket = io("https://wristlink-71b54efd89ef.herokuapp.com");

const Messages = () => {
  const [conversations, setConversations] = useState([]);
  const [text, setText] = useState("");

  socket.on("connect", () => {
    console.log("Connected to server");
  });

  const dealer = JSON.parse(localStorage.getItem("dealer"));

  socket.on("chats", (data) => {
    setConversations(data);
  });

  useEffect(() => {
    socket.emit("chats", dealer?._id);
  }, []);

  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">My Messages</h1>
      <MessangerLayout
        conversations={conversations}
        setConversations={setConversations}
        dealer={dealer}
        text={text}
        setText={setText}
      />
    </div>
  );
};

export default Messages;

const MessangerLayout = ({
  conversations,
  dealer,
  text,
  setText,
  setConversations,
}) => {
  const [activeChat, setActiveChat] = useState(-1);

  const handleText = () => {
    const data = {
      chatId: conversations[activeChat]?.chatId,
      sender: dealer?._id,
      receiver:
        conversations[activeChat].userOne._id === dealer?._id
          ? conversations[activeChat].userTwo._id
          : conversations[activeChat].userOne._id,
      msgType: "text",
      isFlagged: false,
      msg: text,
    };

    socket.emit("msg", data);
    // socket.emit("chats", dealer?._id);
    setText("");
  };

  socket.on("chats", (data) => {
    setConversations(data);
    setActiveChat(0);
    socket.emit("joinRoom", conversations[activeChat]?.chatId);
  });

  return (
    <div className="flex  items-start border rounded-lg ">
      {/* CHAT LEFT SIDE */}
      <div className="w-4/12 border-r p-2 h-[720px] overflow-y-scroll ">
        {conversations?.map((chat, index) => {
          return (
            <Senders
              chat={chat}
              activeChat={activeChat}
              setActiveChat={setActiveChat}
              index={index}
              key={index}
              dealer={dealer}
            />
          );
        })}
      </div>

      {/* CHAT RIGHT SIDE */}
      <div className="w-8/12 ">
        <Chats
          activeChat={activeChat}
          msgs={conversations[activeChat]?.msgs}
          chat={conversations[activeChat]}
          dealer={dealer}
          text={text}
          setText={setText}
          handleText={handleText}
        />
      </div>
    </div>
  );
};

const Senders = ({ chat, activeChat, setActiveChat, index, dealer }) => {
  return (
    <div
      onClick={() => {
        setActiveChat(index);
        socket.emit("joinRoom", chat.chatId);
      }}
      className={` flex justify-between items-center gap-2 my-2 cursor-pointer hover:bg-primary rounded-lg px-2 py-1.5 ${
        activeChat === index && "bg-primary"
      }`}
    >
      <div className="flex items-center gap-2 ">
        <img
          src={
            chat?.userOne?._id === dealer?._id
              ? chat?.userTwo?.avatar
              : chat?.userOne?.avatar
          }
          alt=""
          height={48}
          width={48}
          className="rounded-full border bg-white"
        />
        <div className="lg:block md:block sm:hidden">
          <p className="text-[14px]">
            {chat?.userOne?._id === dealer?._id
              ? chat?.userTwo?.companyTitle
              : chat?.userOne?.companyTitle}
          </p>
          <p className="text-[12px]">
            {chat?.msgs[chat?.msgs?.length - 1]?.msg}
            {/* {chat?.userOne?._id === dealer?._id
              ? chat?.userOne?.companyTitle
              : chat?.userTwo?.companyTitle} */}
          </p>
        </div>
      </div>
      <div className="flex gap-1 items-center">
        <button className=""> {EllipsisVertical}</button>
      </div>
    </div>
  );
};

const Chats = ({
  msgs,
  chat,
  dealer,
  text,
  setText,
  handleText,
  activeChat,
}) => {
  const [chats, setChats] = useState();

  useEffect(() => {
    setChats(chat);
  }, [activeChat]);

  socket.on("msg", (data) => {
    setChats(data);
  });

  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chats?.msgs]);

  return (
    <div className=" flex flex-col justify-between relative h-[720px]">
      {activeChat >= 0 && (
        <>
          <div className="flex items-center gap-4 bg-gray-200 py-2 px-4 ">
            <img
              src={
                chats?.userOne?._id === dealer?._id
                  ? chats?.userTwo?.avatar
                  : chats?.userOne?.avatar
              }
              alt=""
              height={48}
              width={48}
              className="rounded-full border bg-white"
            />
            <div className="lg:block md:block sm:hidden">
              <p className="text-[14px] font-semibold">
                {chats?.userOne?._id === dealer?._id
                  ? chats?.userTwo?.companyTitle
                  : chats?.userOne?.companyTitle}
              </p>
              <p className="text-[12px]">
                {chats?.userOne?._id === dealer?._id
                  ? chats?.userTwo?.country
                  : chats?.userOne?.country}
                {/* {chat?.userOne?._id === dealer?._id
              ? chat?.userOne?.companyTitle
              : chat?.userTwo?.companyTitle} */}
              </p>
            </div>
          </div>

          {/* CHATS */}
          <div
            className="flex flex-col gap-2 p-4 h-[615px] overflow-y-scroll"
            ref={chatContainerRef}
          >
            {chats?.msgs?.map((m, index) => {
              return m?.sender === dealer?._id ? (
                <div className="flex justify-between gap-4">
                  {" "}
                  <div />{" "}
                  <div className="">
                    <p className="px-4 py-2 text-[14px] bg-primarylight rounded-t-full rounded-l-full">
                      {m?.msg}
                    </p>{" "}
                    <p className="text-[10px] text-primary mt-1 ml-3 text-right">
                      {m?.time} {m?.isSeen ? "Seen" : "Sent"}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between gap-4">
                  {" "}
                  <div className="">
                    <p className="px-4 py-2 text-[14px] bg-primarylight rounded-t-full rounded-r-full">
                      {m?.msg}
                    </p>{" "}
                    <p className="text-[10px] text-primary mt-1 mr-3 text-left">
                      {m?.time}
                    </p>
                  </div>
                  <div />{" "}
                </div>
              );
            })}
          </div>

          {/* MESSAGE TYPE */}
          <div className="bg-white  w-full p-6 border flex justify-between gap-4">
            {/* ATTACHMENT BTNS */}
            <div className="flex gap-2">
              <button>{AttachMini} </button>
            </div>

            {/* INPUT FIELD */}
            <div className="px-2 py-1.5 rounded-full bg-[#F3F3F3] flex items-center w-full">
              <input
                type="text"
                placeholder="Reference number, brand, model"
                className="p-1.5 bg-[#F3F3F3] w-full focus:outline-none"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
            </div>

            {/* SEND BTN */}
            <div className="flex gap-2">
              <button onClick={() => handleText()}>{SendMini}</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
